import {
  faArrowUpRightFromSquare,
  faFaceViewfinder,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { ContentBlock } from '~/components/molecules/ContentBlock';
import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { Heading } from '~/components/molecules/Heading';
import { useApi } from '~/lib/api';

export type IAppMembersPageProps = {
  appId: string;
};

export const AppMembersPage: React.FC<IAppMembersPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();
  const api = useApi();
  const region = api.getAuthorization()?.region;

  const path = `/${appId}/users`;
  const url = region
    ? api.getLegacyDashboardUrlWithAuth({
        platform: 'crowd',
        region,
        path,
      })
    : undefined;

  return (
    <>
      <Helmet>
        <title>{t('AppMembersPage.seo.title')}</title>
      </Helmet>

      <Heading
        icon={<FontAwesomeIcon icon={faFaceViewfinder} />}
        title={t('AppMembersPage.title')}
        subtitle={t('AppMembersPage.subtitle')}
        actions={
          <Button
            href={url}
            target="_blank"
            variant="text"
            icon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
            trailingIcon
          >
            {t('common.openInNewWindow')}
          </Button>
        }
      />

      {url ? (
        <ContentBlock draft>
          <ContentBlock.Iframe src={url} title="Legacy Dashboard" />
        </ContentBlock>
      ) : (
        <ErrorMessage>Unknown error.</ErrorMessage>
      )}
    </>
  );
};
